import { InsoleComponent } from "../insole-component/components-config";

export class InsolesPrescriptionMapper {

    rawFlangesDataToForm(foot, insoleComponent, componentConfig: InsoleComponent) {

        let flangesPositions = ['medial', 'lateral'];
        let flangesDimensions = ['width', 'height'];

        flangesPositions.map((position) => {

            flangesDimensions.map((dimension) => {
                foot.map((foot) => {
                    if (position in insoleComponent[foot] && dimension in insoleComponent[foot][position]) {
                        if (componentConfig.selectOptions) {
                            let valueToFind = insoleComponent[foot][position][dimension].value;
                            let foundSelecOption = componentConfig.selectOptions.find((selectOption) => selectOption.value == valueToFind)

                            if (foundSelecOption) {
                                insoleComponent[foot][position][dimension].selectedName = insoleComponent[foot][position][dimension].value;
                            } else {
                                insoleComponent[foot][position][dimension].selectedName = "others";
                            }
                            insoleComponent[foot][position][dimension].value = insoleComponent[foot][position][dimension].value;
                        }
                    }
                });
            })
        })

        return insoleComponent;
    }
}